window.addEventListener("load", function () {
	jQuery(".wp-block-haus-mini-cart-button a").on("click", function (e) {
		e.preventDefault();
		jQuery(this).next().find(".wc-block-mini-cart__button").trigger("click");
	});

	// // select the target node
	// var target = document.querySelector(".wp-block-woocommerce-mini-cart");

	// // create an observer instance
	// var observer = new MutationObserver(function (mutations) {
	// 	mutations.forEach(function (mutation) {
	// 		console.log(mutation.type);
	// 		jQuery(".haus-mini-cart-button-quantity").html(
	// 			"(" + jQuery(".wc-block-mini-cart__badge").html() + ")"
	// 		);
	// 	});
	// });

	// // configuration of the observer:
	// var config = { attributes: true, childList: false, characterData: true };

	// // pass in the target node, as well as the observer options
	// observer.observe(target, config);
	// jQuery("body").on(
	// 	"updated_cart_totals wc_fragments_refreshed wc_fragment_refresh wc_fragments_loaded",
	// 	function () {
	// 		console.log(
	// 			"updated_cart_totals triggered",
	// 			jQuery(".wc-block-mini-cart__badge").html()
	// 		);
	// 		jQuery(".haus-mini-cart-button-quantity").html(
	// 			"(" + jQuery(".wc-block-mini-cart__badge").html() + ")"
	// 		);
	// 		// now.do.whatever();
	// 	}
	// );

	setInterval(updateCartTotal, 1000);

	function updateCartTotal() {
		let total = jQuery(".wc-block-mini-cart__badge").html();
		if (total) {
			jQuery(".haus-mini-cart-button-quantity").html("(" + total + ")");
		} else {
			jQuery(".haus-mini-cart-button-quantity").html("");
		}
	}
});
